<div class="zop-alert-container" *ngIf="!dismissible || dismissible && !dismissed" [@fadeIn]="!dismissed"
    [@fadeOut]="!dismissed">

    <!-- Border -->
    <div class="zop-alert-border" *ngIf="appearance === 'border'"></div>

    <!-- Icon -->
    <div class="zop-alert-icon" *ngIf="showIcon">

        <!-- Custom icon -->
        <div class="zop-alert-custom-icon">
            <ng-content select="[zopAlertIcon]"></ng-content>
        </div>

        <!-- Default icons -->
        <div class="zop-alert-default-icon">

            <mat-icon *ngIf="type === 'primary'" [svgIcon]="'heroicons_solid:check-circle'"></mat-icon>

            <mat-icon *ngIf="type === 'accent'" [svgIcon]="'heroicons_solid:check-circle'"></mat-icon>

            <mat-icon *ngIf="type === 'warn'" [svgIcon]="'heroicons_solid:x-circle'"></mat-icon>

            <mat-icon *ngIf="type === 'basic'" [svgIcon]="'heroicons_solid:check-circle'"></mat-icon>

            <mat-icon *ngIf="type === 'info'" [svgIcon]="'heroicons_solid:information-circle'"></mat-icon>

            <mat-icon *ngIf="type === 'success'" [svgIcon]="'heroicons_solid:check-circle'"></mat-icon>

            <mat-icon *ngIf="type === 'warning'" [svgIcon]="'heroicons_solid:exclamation-triangle'"></mat-icon>

            <mat-icon *ngIf="type === 'error'" [svgIcon]="'heroicons_solid:x-circle'"></mat-icon>

        </div>

    </div>

    <!-- Content -->
    <div class="zop-alert-content">

        <div class="zop-alert-title">
            <ng-content select="[zopAlertTitle]"></ng-content>
        </div>

        <div class="zop-alert-message">
            <ng-content></ng-content>
        </div>

    </div>

    <!-- Dismiss button -->
    <button class="zop-alert-dismiss-button" mat-icon-button (click)="dismiss()">
        <mat-icon [svgIcon]="'heroicons_solid:x-mark'"></mat-icon>
    </button>

</div>